import { ISO8601TimeDuration } from "./iso8601-duration/models";
import { convertToSeconds } from "./iso8601-duration/convert-to-seconds";
import { daysToSeconds } from "./days-to-seconds";

export function convertISO8601DurationToDays(duration: ISO8601TimeDuration): number | null {
    const seconds = convertToSeconds(duration);

    if (seconds === null) {
        return null;
    }

    return Math.round(seconds / daysToSeconds(1));
}
